import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";

import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import InputField from "../../components/form/InputField";
import TextAreaField from "../../components/form/TextAreaField";
import FileInputField from "../../components/form/FileInputField";
import { useDispatch, useSelector } from "react-redux";
import WordInputField from "../../components/form/WordInputField";
import {
  addTaskRecord,
  getStatusTasks,
  setTasks,
} from "../../features/tasksSlice";
import { closeModal } from "../../features/modalSLice";
import { useNotification } from "../../components/notification/NotificationContainer";

const AddTaskNarative = () => {
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const project = useSelector((state) => state.projects.selected);
  const task = useSelector((state) => state.tasks.selected);
  const user = useSelector((state) => state.user.userInfo);
  const addTaskRecordLoad = useSelector(
    (state) => state.tasks.load.addTaskRecord
  );
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      images: [],
      name: "",
    },
    // resolver: zodResolver(AddTaskRecord),
  });

  const onSubmit = async (data, e) => {
    try {
      const res = await dispatch(addTaskRecord({ id: task.id, reqData: data }));
      if (addTaskRecord.fulfilled.match(res)) {
        addNotification("Successfully added Narrative", "success");
        dispatch(closeModal());
        dispatch(getStatusTasks(id));
      } else addNotification(res.payload.message, "error");
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    setValue("task_id", task.id);
    setValue("user_id", user.id);
  }, []);

  return (
    <div className="overflow-auto w-[89vw] sm:w-full flex-col">
      <form
        className=" overflow-auto "
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        encType="multipart/form-data"
      >
        <h4 className="text-center m-7">
          Add Task Record - {task.name || "Nothing"}
        </h4>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row m-auto">
          <InputField
            register={register}
            label="Title"
            name="name"
            type="text"
            errors={errors.name}
          />
        </div>
        {/* <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <NumberInputField
            currencySymbol="$"
            label="Amount Spent"
            name="amount"
            register={register}
            type="number"
            errors={errors.amount}
          />
        </div> */}
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row w-[88vw] sm:w-full">
          <TextAreaField
            className="w-52"
            register={register}
            label="Description"
            name="description"
            setValue={setValue}
            errors={errors.description}
          />
        </div>
        <FileInputField
          accept="image/*"
          name="images"
          label="Choose Images"
          register={register}
          setValue={setValue}
          watch={watch}
          multiple={true}
          maxImages={4}
        />
        {/* <WordInputField
          accept=".pdf, .doc, .docx"
          name="documents"
          label="Choose Files"
          register={register}
          setValue={setValue}
          watch={watch}
          multiple={true}
          maxFiles={4}
        /> */}
        <ResourseButtons loading={addTaskRecordLoad} />
      </form>
    </div>
  );
};

export default AddTaskNarative;
